// ICT-13 Material Shortage rules shared by the shortage follow-up workflow
// (data/workflows/shortageFollowupWorkflow.ts): the shape of a shorted line,
// which material types are never chased (SMRF / VIF), and the internal POD
// guideline (100 pages or less and 50 shorted or less).

export interface ShortageLineItem {
  materialType: string;
  ordered: number;
  received: number;
  shortage: number;
  pages: number;
}

// Doc types we never follow up on for shortages (ICT-13 §6.i exceptions).
export const SKIP_MATERIAL_TYPES = ['SMRF', 'VIF'];

export function isSkippedMaterial(materialType: string): boolean {
  const t = materialType.toUpperCase();
  return SKIP_MATERIAL_TYPES.some(skip => t.includes(skip));
}

// POD eligibility (ICT-13 §7.i): 100 pages or less and 50 shorted or less
// means POD at no cost (an internal call; externally the party is always
// asked to send or pay first), otherwise the manager approves it.
export function evaluatePod(line: { pages: number; shortage: number }): {
  eligible: boolean;
  reason: string;
} {
  if (line.pages <= 100 && line.shortage <= 50) {
    return { eligible: true, reason: `${line.pages}pp and ${line.shortage} shorted, within the internal no-cost POD guideline.` };
  }
  const why = line.pages > 100 ? `${line.pages}pp exceeds the 100-page limit` : `${line.shortage} shorted exceeds the 50-unit limit`;
  return { eligible: false, reason: `${why}, so the manager approves it.` };
}
